import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";
import it from "./locales/it/translation.json";

// Get language from localStorage or default to French
const savedLang = localStorage.getItem("lang") || "fr";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    it: { translation: it },
  },
  lng: savedLang, // ✅ Force language from localStorage or default
  fallbackLng: "fr", // ✅ Fallback to French if key missing
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
